import { selectors as streamSelectors } from '../../Stream';
import { watchedGroupsStreamId, recommendedGroupsStreamId, reduxKey, } from './constants';
function getNetworkBarState(state) {
    var _a;
    return ((_a = state[reduxKey]) !== null && _a !== void 0 ? _a : {
        isInitialized: false,
        mainNavItems: [],
    });
}
export function getIsNetworkBarInitialized(state) {
    return getNetworkBarState(state).isInitialized;
}
export function isNetworkBarLoading(state) {
    return (!streamSelectors.isInitialized(state, watchedGroupsStreamId) ||
        !streamSelectors.isInitialized(state, recommendedGroupsStreamId) ||
        streamSelectors.isFetching(state, watchedGroupsStreamId) ||
        streamSelectors.isFetching(state, recommendedGroupsStreamId));
}
export function getCanUserHaveWatchedGroups(state) {
    return (streamSelectors.getItems(state, watchedGroupsStreamId).length > 0 ||
        streamSelectors.isFetching(state, watchedGroupsStreamId) ||
        streamSelectors.hasMore(state, watchedGroupsStreamId));
}
export function getMainNavNewContent(state) {
    return getNetworkBarState(state).mainNavigation;
}
//# sourceMappingURL=selectors.js.map